// internationalization
import type { TFunction } from 'i18next';

// libraries
import { z } from 'zod';

/** Local shape for the subset of a Unit's fields this form actually reads (units come from the untyped legacy `unitsApiSlice`, no generated DTO exists). */
export interface SelectableUnit {
  UnitId: number;
  Name: string;
  UnitType?: { UnitTypeId?: number };
  UnitSensors?: {
    Sensor?: { SensorId?: number; CalibrationType?: string };
  }[];
  Tags?: { TagId: number; Text: string }[];
}

const openingHoursDaySchema = z.array(
  z.object({ start: z.number(), end: z.number() }),
);

const openingHoursSchema = z.object({
  monday: openingHoursDaySchema,
  tuesday: openingHoursDaySchema,
  wednesday: openingHoursDaySchema,
  thursday: openingHoursDaySchema,
  friday: openingHoursDaySchema,
  saturday: openingHoursDaySchema,
  sunday: openingHoursDaySchema,
});

export type OpeningHoursValue = z.infer<typeof openingHoursSchema>;

export function createFirstNodeFormSchema(t: TFunction) {
  return z.object({
    name: z.string().min(1, t('input.required', { ns: 'validation' })),
    units: z.array(z.custom<SelectableUnit>()),
    openingHours: openingHoursSchema,
  });
}

export type CreateFirstNodeFormValues = z.infer<
  ReturnType<typeof createFirstNodeFormSchema>
>;
